import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CalendarOptions, EventClickArg } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import { IonModal, ModalController } from '@ionic/angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { EntityPickerModalComponent } from '../components/entity-picker-modal/entity-picker-modal.component';
import { OAuthService } from 'angular-oauth2-oidc';
import { firstValueFrom } from 'rxjs';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { DataService } from '../data.service';
import { font } from '../util/pdf-fontok/Bitter-Regular-normal';
import { fontB } from '../util/pdf-fontok/Bitter-Bold-normal';
import { TANEVRENDJE_TIPUSOK } from './tanevrendje-tipusok';
import { TktOrarendModalComponent } from './tkt-orarend-modal/tkt-orarend-modal.component';
import { TanevrendjeRendeletModalComponent } from './tanevrendje-rendelet-modal/tanevrendje-rendelet-modal.component';
import { DigitalisMunkarendModalComponent } from './digitalis-munkarend-modal/digitalis-munkarend-modal.component';
import { PENZNEMEK, osszegSzoveg, penznemKod } from '../util/penznem';

// Egyesített naptár: a szerepkör dönti el a képességeket.
//  - munkatárs: felvehet újat; szerkeszteni a SAJÁTJÁT tudja (amit ő vett fel, vagy
//    aminek ő a felelőse), admin jogkörrel mindet – a döntést a kiszolgáló hozza,
//    soronként (`szerkesztheto`), lásd backend/naptar-jog.js
//  - gondviselő (szülő): olvasás + jelentkezés
//  - tanuló: olvasás
@Component({
  selector: 'app-naptar',
  templateUrl: './naptar.component.html',
  styleUrls: ['./naptar.component.scss'],
})
export class NaptarComponent implements OnInit {
  @ViewChild('reszletekmodal') reszletekmodal: IonModal;
  @ViewChild('szerkesztomodal') szerkesztomodal: IonModal;
  @ViewChild('feliratkozasmodal') feliratkozasmodal: IonModal;

  /*  A típusok TÖRZSADATOK (Admin → Naptártípusok). A beépített lista csak tartalék,
   *  amíg a lekérés meg nem jön – vagy ha elbukik, ne álljon üresen a választó. */
  tipusok: { value: string; label: string; color: string; icon: string; rejtett?: boolean }[] = TANEVRENDJE_TIPUSOK;
  // Holiday-típusok az ebéd/napló-kezeléshez (a holiday.type szemantikája szerint).
  //  0  = munkaszüneti nap/ünnep -> kizárja a napot (senki nem dolgozik)
  //  1  = iskolai szünet         -> MARAD munkanap (szabadság írható), nincs tanítás
  // -2  = áthelyezett munkanap   -> hétvégi tanítási nap (beszámít)
  holidayTipusok = [
    { value: null, label: 'Nem kerül a tanügyi naptárba' },
    { value: 0, label: 'Munkaszüneti nap / ünnep (nincs munka, az órák törlődnek)' },
    { value: 1, label: 'Iskolai szünet / tanítás nélküli nap (az órák törlődnek)' },
    { value: -2, label: 'Áthelyezett munkanap (hétvégi tanítás)' },
  ];
  intezmeny = '';
  uuid = '';
  loginMode = '';
  esemenyek: any[] = [];

  /*  Az ár pénzneme: a jelentkezős programok (pl. külföldi sítábor) nem mindig forintban
   *  fizetendők. A lista zárt – a kiszolgáló ugyanezt fogadja el. */
  readonly penznemek = PENZNEMEK;
  arSzoveg(e: any): string { return osszegSzoveg(e?.ar, e?.ar_penznem); }

  // Szülői nézethez: gyerekek + scope-szűréshez az osztály- és csoport-azonosítóik.
  gyerekek: any[] = [];
  sajatOsztalyIds = new Set<string>();
  sajatCsoportIds = new Set<string>();

  // Szerkesztéshez (dolgozó): scope-listák.
  akttev: any = null;
  osztalyok: any[] = [];
  csoportok: any[] = [];
  /*  Felelős tanár választásához a kollégák listája. Csak dolgozói szerkesztéskor
   *  töltjük be – szülői nézetben nincs rá szükség, és a névsor személyes adat.
   */
  munkatarsak: any[] = [];
  felelosSzuro = '';

  // Részletek (szülő) + szerkesztett bejegyzés (dolgozó).
  f: any = null;
  jelentkezok: string[] = [];
  ef: any = null;

  /*  NAPTÁR-FELIRATKOZÁS. A programokat eddig kézzel kellett átvezetni a saját
   *  naptárba – ami egyszeri művelet, tehát a KÉSŐBBI változásról (elmaradt program,
   *  áthelyezett időpont) már nem tudott. A feliratkozás ezt megoldja: a külső
   *  naptár maga kérdez rá időnként. */
  linkek: any = null;
  linkFut = false;

  // Az éppen megjelenített naptár-nézet tartománya (a kártyalista ehhez igazodik).
  viewStart: Date | null = null;
  viewEnd: Date | null = null;

  /*  TELEFONON HETI NÉZET (2026-10-15, a user kérése). A havi rács keskeny képernyőn
   *  szétcsúszik: a napok cellái túl szűkek, az események feliratai egymásra futnak. Ezért
   *  768 px alatt (telefon) heti nézettel nyílik, fölötte (tablet, asztali gép) maradt a
   *  havi. Átméretezéskor / elforgatáskor a határ átlépésekor magától vált; kézzel a
   *  fejlécben továbbra is lehet hónap és hét között váltani. A heti nézet a napi rácsé
   *  (dayGridWeek): a tanév rendje eseményei többnyire egész naposak, az idősávos rács
   *  telefonon üres sávokkal lenne tele. */
  private static readonly MOBIL_HATAR = 768;
  private mobilE = (w = window.innerWidth) => w < NaptarComponent.MOBIL_HATAR;
  private mobilNezet = this.mobilE();

  calendarOptions: CalendarOptions = {
    initialView: this.mobilNezet ? 'dayGridWeek' : 'dayGridMonth',
    plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
    locale: 'hu',
    firstDay: 1,
    height: 'auto',
    events: [],
    headerToolbar: this.mobilNezet
      ? { left: 'prev,next', center: 'title', right: 'today dayGridWeek,dayGridMonth' }
      : { left: 'prev,next today', center: 'title', right: 'dayGridMonth,timeGridWeek' },
    views: {
      //  Telefonon a hét fejlécében a nap száma is kell (a „H 12.” egyértelmű, a „H” nem).
      dayGridWeek: { dayHeaderFormat: { weekday: 'short', day: 'numeric' }, eventDisplay: 'block' },
    },
    windowResize: (arg: any) => this.zone.run(() => this.meretValt(arg?.view)),
    buttonText: { today: 'Ma', month: 'Hónap', week: 'Hét' },
    /*  EGÉSZ ÓRÁNÁL IS KIÍRJUK A PERCET.
     *
     *  A FullCalendar alapból elhagyja a nullát ("8" a 8:00 helyett), amitől a
     *  havi nézetben az időpont sorszámnak látszik – a 8-as esemény és a 8. óra
     *  egy pillanatra ugyanaz. Perccel együtt egyértelmű, hogy időpont.
     */
    eventTimeFormat: { hour: 'numeric', minute: '2-digit', omitZeroMinute: false, hour12: false },
    dayHeaderFormat: { weekday: 'short' },
    eventClick: (arg: EventClickArg) => this.onEventClick(arg),
    dateClick: (arg: any) => { if (this.staffMode) this.ujBejegyzes(arg?.dateStr); },
    // A megjelenített tartomány követése a kártyalista szűréséhez.
    datesSet: (arg: any) => this.zone.run(() => { this.viewStart = arg.start; this.viewEnd = arg.end; }),
  };

  /** A telefon/tablet határ átlépésekor nézet- és fejléccsere. */
  private meretValt(view: any): void {
    const mobil = this.mobilE();
    if (mobil === this.mobilNezet) return;
    this.mobilNezet = mobil;
    const api = view?.calendar;
    api?.setOption('headerToolbar', mobil
      ? { left: 'prev,next', center: 'title', right: 'today dayGridWeek,dayGridMonth' }
      : { left: 'prev,next today', center: 'title', right: 'dayGridMonth,timeGridWeek' });
    api?.changeView(mobil ? 'dayGridWeek' : 'dayGridMonth');
  }

  constructor(public oauth: OAuthService, private data: DataService, private http: HttpClient, private zone: NgZone, private modalCtrl: ModalController, private sanitizer: DomSanitizer) {}

  // Az aktuálisan választott scope (osztály/csoport) rövid összegzője a gombon.
  scopeOsszegzo(): string {
    const ids = Array.isArray(this.ef?.scope_ids) ? this.ef.scope_ids.map((x: any) => String(x)) : [];
    if (!ids.length) return 'Válassz…';
    const forras = this.ef.scope_tipus === 'osztaly' ? this.osztalyok : this.csoportok;
    const nevMezo = this.ef.scope_tipus === 'osztaly' ? 'osztaly' : 'name';
    const nevek = forras
      .filter((x: any) => ids.includes(String(x.id)))
      .map((x: any) => x[nevMezo]);
    if (nevek.length <= 2) return nevek.join(', ');
    return `${nevek.slice(0, 2).join(', ')} +${nevek.length - 2}`;
  }

  /*  NÉVRE SZÓLÓ ÉRINTETTEK.
   *
   *  A hatókör csoportokban gondolkodik, a valóság viszont nem mindig: egy kirándulásra
   *  elmegy egy technikai dolgozó is, egy értekezletre meghívnak egy kollégát a másik
   *  körből. Ez a lista EZEN FELÜL van – nem szűkíti a hatókört, csak kiegészíti. */
  szemelyOsszegzo(): string {
    const ids = Array.isArray(this.ef?.erintett_szemelyek)
      ? this.ef.erintett_szemelyek.map((x: any) => String(x)) : [];
    if (!ids.length) return 'Nincs';
    const nevek = ids.map((id: string) => this.felelosNev(id));
    if (nevek.length <= 2) return nevek.join(', ');
    return `${nevek.slice(0, 2).join(', ')} +${nevek.length - 2}`;
  }

  /*  TÖBB FELELŐS.
   *
   *  Egy programnak a gyakorlatban több gazdája van (két kísérő tanár, a szervező és a
   *  szakmai felelős). Eddig egyetlen mező volt, tehát a másodikat nem lehetett
   *  rögzíteni – és ő nem is szerkeszthette a bejegyzést, nem kapott értesítést, és a
   *  naptárába sem került be. */
  felelosOsszegzo(): string {
    const ids = Array.isArray(this.ef?.felelosok) ? this.ef.felelosok.map((x: any) => String(x)) : [];
    if (!ids.length) return 'Nincs kijelölve';
    const nevek = ids.map((id: string) => this.felelosNev(id));
    if (nevek.length <= 2) return nevek.join(', ');
    return `${nevek.slice(0, 2).join(', ')} +${nevek.length - 2}`;
  }

  async felelosPickerNyitas() {
    const items = (this.munkatarsak || []).map((m: any) => ({
      id: String(m.adid),
      label: `${m.viselt_vez || ''} ${m.viselt_ker || ''}`.trim() || String(m.adid),
      sublabel: m.munkakor || undefined,
    }));
    const modal = await this.modalCtrl.create({
      component: EntityPickerModalComponent,
      componentProps: {
        title: 'Felelősök',
        searchPlaceholder: 'Munkatárs neve…',
        multiple: true,
        selectedIds: Array.isArray(this.ef.felelosok) ? [...this.ef.felelosok] : [],
        items,
      },
    });
    await modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role === 'confirm' && data?.ids) {
      this.ef.felelosok = data.ids.map((x: any) => String(x));
    }
  }

  async szemelyPickerNyitas() {
    const items = (this.munkatarsak || []).map((m: any) => ({
      id: String(m.adid),
      label: `${m.viselt_vez || ''} ${m.viselt_ker || ''}`.trim() || String(m.adid),
      sublabel: m.munkakor || undefined,
    }));
    const modal = await this.modalCtrl.create({
      component: EntityPickerModalComponent,
      componentProps: {
        title: 'Kit érint még?',
        searchPlaceholder: 'Munkatárs neve…',
        multiple: true,
        selectedIds: Array.isArray(this.ef.erintett_szemelyek) ? [...this.ef.erintett_szemelyek] : [],
        items,
      },
    });
    await modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role === 'confirm' && data?.ids) {
      this.ef.erintett_szemelyek = data.ids.map((x: any) => String(x));
    }
  }

  async scopePickerNyitas(tipus: 'osztaly' | 'csoport') {
    const forras = tipus === 'osztaly' ? this.osztalyok : this.csoportok;
    const items = forras.map((x: any) =>
      tipus === 'osztaly'
        ? { id: x.id, label: x.osztaly }
        : { id: x.id, label: x.name, sublabel: x.ev ? `${x.ev}` : undefined }
    );
    const modal = await this.modalCtrl.create({
      component: EntityPickerModalComponent,
      componentProps: {
        title: tipus === 'osztaly' ? 'Osztályok választása' : 'Csoportok választása',
        searchPlaceholder: tipus === 'osztaly' ? 'Osztály neve…' : 'Csoport neve…',
        multiple: true,
        selectedIds: Array.isArray(this.ef.scope_ids) ? [...this.ef.scope_ids] : [],
        items,
      },
    });
    await modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role === 'confirm' && data?.ids) {
      this.ef.scope_ids = data.ids;
      // A hatókör változott: az ebédlemondás előnézete (hány tanuló) is változik.
      this.ebedElonezetBetolt();
    }
  }

  get intezmenyPath(): string { return encodeURI(this.intezmeny); }
  get szuloMode(): boolean { return this.loginMode === 'gondviselo'; }
  get diakMode(): boolean { return this.loginMode === 'tanulo'; }
  /*  MUNKATÁRS-E A BELÉPŐ?
   *
   *  Ez korábban „nem szülő" volt – így a DIÁK is a szerkesztőt kapta, és minden
   *  eseményt látott, a még nem publikált piszkozatokat is.
   *
   *  A szigorú „csak ha dolgozo" viszont túl szigorú volt: ha a belépési mód bármiért
   *  HIÁNYZIK a tárolóból, attól a munkatárs még munkatárs – eltűnt volna előle az
   *  „Új esemény" gomb, és nem tudott volna felvenni semmit. A hiányzó érték ezért
   *  nem zár ki; a diákot és a szülőt a saját, MINDIG eltárolt módjuk zárja ki.
   *  A tényleges jogot úgyis a kiszolgáló dönti el – a felület csak jelez. */
  get staffMode(): boolean {
    const mod = String(this.loginMode || '').trim();
    return !mod || mod === 'dolgozo';
  }

  /*  SZERKESZTHETI-E EZT A BEJEGYZÉST?
   *
   *  A választ a kiszolgáló adja soronként (`szerkeszthető`), mert csak ő ismeri a
   *  jogköröket – és mert ugyanez a szabály zárja a mentést is. Ha itt magunk
   *  következtetnénk rá, a felület és a kiszolgáló előbb-utóbb mást mondana. */
  szerkesztheto(e: any): boolean {
    return this.staffMode && !!Number(e?.szerkesztheto);
  }

  async ngOnInit() {
    await this.oauth.loadUserProfile();
    const claims: any = this.data.belepoKilet(this.oauth.getIdentityClaims() || {});
    this.uuid = claims.username || claims.preferred_username;
    const si = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = String(si?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    this.loginMode = await this.data.getFromStorage('loginmode');
    try { this.akttev = JSON.parse(await this.data.getFromStorage('tanev'))?.aktualistanev; } catch { this.akttev = null; }

    // A diák ugyanazon a végponton kapja meg a SAJÁT sorát („saját" rokonsággal),
    // amin a szülő a gyerekeit – így az osztály/csoport szerinti szűrés neki is működik.
    await this.loadTipusok();
    if (this.staffMode) await this.loadScope();
    else await this.loadGyerekek();
    await this.loadEsemenyek();
  }

  async loadTipusok() {
    if (!this.intezmeny) return;
    try {
      const lista: any = await firstValueFrom(this.http.get(`/api/naptar-tipusok/${this.intezmeny}`));
      if (Array.isArray(lista) && lista.length) {
        this.tipusok = lista.map((t: any) => ({
          value: String(t.kulcs), label: String(t.nev), color: String(t.szin || '#3880ff'),
          icon: String(t.ikon || 'ellipsis-horizontal'), rejtett: !!t.rejtett,
        }));
      }
    } catch { /* marad a beépített lista */ }
  }

  /** Új eseménynél csak a nem rejtett típus választható; a meglévő esemény saját típusa marad. */
  get valaszthatoTipusok() {
    const aktualis = this.ef?.tipus;
    return this.tipusok.filter((t) => !t.rejtett || t.value === aktualis);
  }

  // ── Betöltés ──────────────────────────────────────────────────────────
  async loadGyerekek() {
    try {
      const rsp: any = await firstValueFrom(
        this.http.get(`/api/nyilvantartas/szulogyereke/${this.uuid}/${this.intezmenyPath}`)
      );
      /*  A VÉGPONT MAGÁT A LISTÁT ADJA VISSZA, nem egy `gyermekek` mezős objektumot.
       *  Emiatt a lista itt MINDIG üres maradt: a szülő ezért csak az intézményi
       *  hatókörű eseményeket látta (az osztályára szólót nem), és a jelentkezés-blokk
       *  sem jelent meg soha, mert `gyerekek.length` nulla volt. Mindkét alakot
       *  elfogadjuk, hogy a régebbi telepítéseken se boruljon fel. */
      let gyermekek = Array.isArray(rsp) ? rsp : rsp?.gyermekek;
      if (typeof gyermekek === 'string') { try { gyermekek = JSON.parse(gyermekek); } catch { gyermekek = []; } }
      this.gyerekek = (Array.isArray(gyermekek) ? gyermekek : []).filter(Boolean);
      this.gyerekek.forEach((gy) => { if (gy?.osztaly_id) this.sajatOsztalyIds.add(String(gy.osztaly_id)); });

      const oktazonok = this.gyerekek.map((gy) => String(gy?.oktazon || '').trim()).filter(Boolean);
      if (oktazonok.length) {
        const csoportok = await firstValueFrom(
          this.http.post<string[]>(`/api/tanevrendje/gyerek-csoportjai/${this.intezmenyPath}`, { oktazonok })
        ) || [];
        csoportok.forEach((id) => this.sajatCsoportIds.add(String(id)));
      }
    } catch (e) { console.warn('Gyerekek betöltési hiba:', e); }
  }

  async loadScope() {
    try {
      const [osztalyok, csoportok] = await Promise.all([
        this.akttev
          ? firstValueFrom(this.http.get<any[]>(`/api/nyilvantartas/osztaly/${this.akttev}/${this.intezmenyPath}`))
          : Promise.resolve([]),
        firstValueFrom(this.http.get<any[]>(`/api/nyilvantartas/csoport/${this.intezmenyPath}`)),
      ]);
      this.osztalyok = Array.isArray(osztalyok) ? osztalyok : [];
      this.csoportok = Array.isArray(csoportok) ? csoportok : [];
    } catch (e) { console.warn('Scope listák betöltési hiba:', e); }
    try {
      const all: any = await firstValueFrom(this.data.getAllomany(this.intezmenyPath));
      this.munkatarsak = Array.isArray(all) ? all : [];
    } catch (e) { this.munkatarsak = []; }
  }

  /** A felelős-választó listája: névsorban, keresővel szűrve. */
  get szurtMunkatarsak(): any[] {
    const nev = (m: any) => `${m?.viselt_vez || ''} ${m?.viselt_ker || ''}`.trim();
    const keres = this.felelosSzuro.trim().toLowerCase();
    return (this.munkatarsak || [])
      .filter((m: any) => !keres || nev(m).toLowerCase().includes(keres)
        || String(m?.adid || '').toLowerCase().includes(keres))
      .sort((a: any, b: any) => nev(a).localeCompare(nev(b), 'hu'));
  }

  felelosNev(adid: any): string {
    const m = (this.munkatarsak || []).find((x: any) => String(x.adid) === String(adid));
    return m ? `${m.viselt_vez || ''} ${m.viselt_ker || ''}`.trim() : String(adid || '');
  }

  async loadEsemenyek() {
    await this.data.showLoading('Naptár betöltése...');
    try {
      const osszes = await firstValueFrom(this.http.get<any[]>(`/api/tanevrendje/${this.intezmenyPath}`)) || [];
      this.esemenyek = this.alprogramokCsoportosit(this.temakEpit(osszes.filter((e) => this.lathato(e))));
      this.calendarOptions = { ...this.calendarOptions, events: this.esemenyek.map((e) => this.toCalendarEvent(e)) };
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Nem sikerült betölteni a naptárat.', 'error');
    } finally { await this.data.hideLoading(); }
  }

  /* ══════════════════════════════════════════════════════════════════════
   *  A LEÍRÁSBAN LÉVŐ HIVATKOZÁS LEGYEN KATTINTHATÓ.
   *
   *  A leírásba sokszor kerül cím (jelentkezési lap, útvonal, hírlevél), amit
   *  eddig ki kellett jelölni és átmásolni. Kattinthatóvá tesszük – ÚJ ABLAKBAN,
   *  mert a naptárból elnavigálni nem szabad: aki épp jelentkezést nézeget, ne
   *  veszítse el a listát.
   *
   *  A szöveget ELŐBB elrejtjük (escape), és csak utána illesztjük bele a
   *  hivatkozásokat: így egy leírásba írt HTML nem tud megjelenni és nem tud
   *  futni. A `bypassSecurityTrust` ezért biztonságos itt – nem idegen HTML-t
   *  engedünk át, hanem a magunk által, escape-elt darabokból épített szöveget.
   * ═══════════════════════════════════════════════════════════════════════ */
  private static readonly URL_MINTA = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/gi;

  private szovegEscape(t: string): string {
    return String(t ?? '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  private linkesit(nyers: any): SafeHtml {
    const szoveg = String(nyers ?? '');
    if (!szoveg) return '';
    let ki = '';
    let utolso = 0;
    const minta = new RegExp(NaptarComponent.URL_MINTA.source, 'gi');
    let t: RegExpExecArray | null;
    while ((t = minta.exec(szoveg)) !== null) {
      ki += this.szovegEscape(szoveg.slice(utolso, t.index));
      // A mondatvégi írásjel nem a cím része: „…lásd www.pelda.hu." → a pont marad kint.
      let cim = t[0];
      let farok = '';
      const vagas = cim.match(/[.,;:!?)\]}]+$/);
      if (vagas) { farok = vagas[0]; cim = cim.slice(0, -farok.length); }
      const href = /^https?:\/\//i.test(cim) ? cim : `https://${cim}`;
      ki += `<a href="${this.szovegEscape(href)}" target="_blank" rel="noopener noreferrer">`
          + `${this.szovegEscape(cim)}</a>${this.szovegEscape(farok)}`;
      utolso = t.index + t[0].length;
    }
    ki += this.szovegEscape(szoveg.slice(utolso));
    // Sortörés megtartása: a leírás gyakran több soros.
    return this.sanitizer.bypassSecurityTrustHtml(ki.replace(/\n/g, '<br>'));
  }

  /*  A kártya egésze kattintható (megnyitja az eseményt) – a benne lévő hivatkozás
   *  viszont nem az eseményt nyissa meg, hanem a címet. */
  linkKattintas(esemeny: Event) {
    const cel = esemeny.target as HTMLElement;
    if (cel?.closest?.('a')) esemeny.stopPropagation();
  }

  /*  Egyszer számoljuk ki, betöltéskor: a sablonból hívott változat minden
   *  változás-ellenőrzésnél új objektumot adna vissza, és a nézet folyton
   *  újrarajzolna. */
  private temakEpit(lista: any[]): any[] {
    return (lista || []).map((e) => ({ ...e, tema_html: this.linkesit(e?.tema) }));
  }

  /*  AL-PROGRAMOK (pl. nyílt nap – három külön jelentkezhető foglalkozás). Az al-program
   *  maga is bejegyzés (`szulo_id` a fő eseményre), de a naptárban és a kártyák között
   *  NEM külön elem: a fő esemény alatt, annak `alprogramok` listájában jelenik meg.
   *  Ha a fő esemény valamiért nem látszik, az al-program önállóan marad látható. */
  private alprogramokCsoportosit(lista: any[]): any[] {
    const idk = new Set(lista.map((e) => String(e.id)));
    const alok = new Map<string, any[]>();
    for (const e of lista) {
      if (!e.szulo_id || !idk.has(String(e.szulo_id))) continue;
      const k = String(e.szulo_id);
      if (!alok.has(k)) alok.set(k, []);
      alok.get(k)!.push(e);
    }
    const sorrend = (a: any, b: any) => (new Date(a.kezdes).getTime() - new Date(b.kezdes).getTime())
      || String(a.nev || '').localeCompare(String(b.nev || ''), 'hu');
    return lista
      .filter((e) => !e.szulo_id || !idk.has(String(e.szulo_id)))
      .map((e) => ({ ...e, alprogramok: (alok.get(String(e.id)) || []).sort(sorrend) }));
  }

  /** Jelentkezős-e az esemény vagy valamelyik al-programja (a naptárbeli 📝 jelhez). */
  vanJelentkezes(e: any): boolean {
    return !!e?.jelentkezheto || (e?.alprogramok || []).some((a: any) => !!a.jelentkezheto);
  }

  // Láthatóság: munkatárs mindent lát; szülő és diák csak a publikáltakat, a saját
  // (gyermeke) osztálya/csoportja szerint.
  private lathato(e: any): boolean {
    /*  A DOLGOZÓI HATÓKÖRT A KISZOLGÁLÓ SZŰRI (oda se küldi ki, aki nem tartozik bele);
     *  itt csak azért ismételjük meg, hogy a felület magától is helyes maradjon, ha
     *  valaha gyorsítótárból vagy régi válaszból dolgozna. */
    if (e.scope_tipus === 'dolgozo' && !this.staffMode) return false;
    if (this.staffMode) return true;
    if (!e.publikalt) return false;
    if (e.scope_tipus === 'intezmeny') return true;
    if (e.scope_tipus === 'osztaly') {
      const ids = Array.isArray(e.scope_ids) ? e.scope_ids.map((x: any) => String(x)) : [];
      return ids.some((id) => this.sajatOsztalyIds.has(id));
    }
    if (e.scope_tipus === 'csoport') {
      const ids = Array.isArray(e.scope_ids) ? e.scope_ids.map((x: any) => String(x)) : [];
      return ids.some((id) => this.sajatCsoportIds.has(id));
    }
    return true;
  }

  // ── Típus-megjelenítés ────────────────────────────────────────────────
  private tipusMeta(tipus: string) {
    return this.tipusok.find((t) => t.value === tipus)
      || this.tipusok.find((t) => t.value === 'program') || this.tipusok[0] || TANEVRENDJE_TIPUSOK[0];
  }
  tipusLabel(tipus: string): string { return this.tipusMeta(tipus).label; }
  tipusColor(tipus: string): string { return this.tipusMeta(tipus).color; }
  tipusIcon(tipus: string): string { return this.tipusMeta(tipus).icon; }

  private toCalendarEvent(e: any) {
    const meta = this.tipusMeta(e.tipus);
    const allDay = !!e.egesz_napos;
    // FullCalendar egész napos eseménynél az 'end' KIZÁRÓLAGOS, ezért +1 nap,
    // különben a több napos szünet utolsó napja nem látszik (pl. jún 18-19 → csak 18).
    let end = e.vege;
    if (allDay && e.vege) {
      const d = new Date(e.vege);
      if (!Number.isNaN(d.getTime())) {
        d.setDate(d.getDate() + 1);
        const pad = (n: number) => String(n).padStart(2, '0');
        end = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
      }
    }
    return {
      id: e.id,
      title: (this.vanJelentkezes(e) ? '📝 ' : '') + e.nev,
      start: e.kezdes, end, allDay,
      backgroundColor: meta.color, borderColor: meta.color,
      extendedProps: { raw: e },
    };
  }

  private onEventClick(arg: EventClickArg) {
    const raw = (arg.event.extendedProps as any)?.raw;
    if (raw) this.openKartya(raw);
  }

  // Kártya/esemény megnyitása: aki szerkesztheti, a szerkesztőt kapja; mindenki más
  // az olvasó nézetet – a tanár is, ha a kolléga programjára kattint.
  openKartya(e: any) {
    if (this.szerkesztheto(e)) this.szerkeszt(e);
    else this.openReszletek(e);
  }

  // A kártyalista a megjelenített naptár-nézet tartományába eső eseményeket mutatja.
  get kozelgoEsemenyek(): any[] {
    const lista = (this.esemenyek || []).filter((e) => this.nezetbenVan(e));
    return lista.sort((a, b) => new Date(a.kezdes).getTime() - new Date(b.kezdes).getTime());
  }

  private nezetbenVan(e: any): boolean {
    // Amíg nincs ismert nézet-tartomány, esik vissza a "mai naptól" logikára.
    if (!this.viewStart || !this.viewEnd) {
      const ma = new Date(); ma.setHours(0, 0, 0, 0);
      const veg = e.vege ? new Date(e.vege) : (e.kezdes ? new Date(e.kezdes) : null);
      return veg ? veg >= ma : true;
    }
    const start = e.kezdes ? new Date(e.kezdes) : null;
    const end = e.vege ? new Date(e.vege) : start;
    if (!start) return false;
    // Átfedés a megjelenített [viewStart, viewEnd) tartománnyal.
    return start < this.viewEnd && (end || start) >= this.viewStart;
  }

  szabadHely(e: any): number | null {
    if (!e?.jelentkezheto || !e?.letszam) return null;
    //  A szülő csak a saját gyermekeit kapja a jelentkezők közül; a létszám külön jön.
    const db = e.jelentkezok_db ?? (Array.isArray(e.jelentkezok) ? e.jelentkezok.length : 0);
    return Math.max(0, Number(e.letszam) - db);
  }

  // ── Szülői részletek + jelentkezés ────────────────────────────────────
  /*  Al-programonként a szülő választása: { al-program id → a jelentkeztetett gyermekek }.
   *  Az eredeti állapot külön, hogy mentéskor csak a ténylegesen módosított programhoz
   *  menjen kérés (egy lezárt vagy betelt program ne adjon hibát, ha hozzá sem nyúlt). */
  alJelentkezok: Record<string, string[]> = {};
  private alJelentkezokEredeti: Record<string, string> = {};

  openReszletek(e: any) {
    this.f = e;
    this.jelentkezok = Array.isArray(e.jelentkezok) ? e.jelentkezok.map((x: any) => String(x)) : [];
    this.alJelentkezok = {};
    this.alJelentkezokEredeti = {};
    for (const a of e.alprogramok || []) {
      const lista = Array.isArray(a.jelentkezok) ? a.jelentkezok.map((x: any) => String(x)) : [];
      this.alJelentkezok[a.id] = lista;
      this.alJelentkezokEredeti[a.id] = JSON.stringify([...lista].sort());
    }
    this.reszletekmodal.present();
  }
  closeReszletek() { this.reszletekmodal.dismiss(); }

  /** Nyitva van-e most a jelentkezés az adott (fő- vagy al-) programra. */
  nyitva(e: any): boolean {
    if (!e?.jelentkezheto) return false;
    const ma = new Date(); ma.setHours(0, 0, 0, 0);
    const tol = e.jelentkezes_tol ? new Date(e.jelentkezes_tol) : null;
    const ig = e.jelentkezes_ig ? new Date(e.jelentkezes_ig) : null;
    if (tol && ma < tol) return false;
    if (ig && ma > ig) return false;
    return true;
  }
  get jelentkezesNyitva(): boolean { return this.nyitva(this.f); }
  /** Van-e a megnyitott eseményen bármi, amire most jelentkezni lehet (a mentés gombhoz). */
  get barmiNyitva(): boolean {
    return this.jelentkezesNyitva || (this.f?.alprogramok || []).some((a: any) => this.nyitva(a));
  }
  isJelentkezett(oktazon: any): boolean { return this.jelentkezok.includes(String(oktazon)); }
  setJelentkezes(gyerek: any, selected: boolean) {
    const oktazon = String(gyerek?.oktazon || '').trim();
    if (!oktazon) return;
    const s = new Set(this.jelentkezok);
    if (selected) s.add(oktazon); else s.delete(oktazon);
    this.jelentkezok = [...s];
  }
  isAlJelentkezett(a: any, oktazon: any): boolean {
    return (this.alJelentkezok[a?.id] || []).includes(String(oktazon));
  }
  setAlJelentkezes(a: any, gyerek: any, selected: boolean) {
    const oktazon = String(gyerek?.oktazon || '').trim();
    if (!oktazon || !a?.id) return;
    const s = new Set(this.alJelentkezok[a.id] || []);
    if (selected) s.add(oktazon); else s.delete(oktazon);
    this.alJelentkezok = { ...this.alJelentkezok, [a.id]: [...s] };
  }

  async jelentkez() {
    if (!this.f) return;
    this.closeReszletek();
    await this.data.showLoading('Mentés...');
    const sajat = this.gyerekek.map((o) => String(o.oktazon || '').trim()).filter(Boolean);
    const kuld = (id: string, jelentkezok: string[]) => firstValueFrom(
      this.http.post(`/api/tanevrendje/jelentkezes/${id}`, { intezmeny: this.intezmeny, sajat, jelentkezok }));
    /*  Programonként külön kérés: ha az egyik betelt, a többi jelentkezés attól még
     *  bekerül – és a hibát a program nevével mondjuk meg. */
    const hibak: string[] = [];
    let mentve = 0;
    if (this.jelentkezesNyitva) {
      try { await kuld(this.f.id, this.jelentkezok); mentve++; }
      catch (err: any) { hibak.push(`${this.f.nev}: ${err?.error?.error || 'nem sikerült'}`); }
    }
    for (const a of this.f.alprogramok || []) {
      const lista = this.alJelentkezok[a.id] || [];
      if (!this.nyitva(a) || JSON.stringify([...lista].sort()) === this.alJelentkezokEredeti[a.id]) continue;
      try { await kuld(a.id, lista); mentve++; }
      catch (err: any) { hibak.push(`${a.nev}: ${err?.error?.error || 'nem sikerült'}`); }
    }
    await this.data.hideLoading();
    if (hibak.length) this.data.sendToast(`${mentve ? 'Részben mentve. ' : ''}${hibak.join(' ')}`, 'error');
    else this.data.sendToast('Jelentkezés mentve.', 'success');
    await this.loadEsemenyek();
  }

  // ── Dolgozói szerkesztő (CRUD) ────────────────────────────────────────
  ujBejegyzes(datum?: string) {
    this.ef = {
      id: null, nev: '', tipus: 'program', tema: '', ikon: '',
      kezdes: datum ? `${datum}T08:00` : '', vege: datum ? `${datum}T09:00` : '',
      egesz_napos: false, scope_tipus: 'intezmeny', scope_ids: [],
      dolgozoi_kor: 'mind', erintett_szemelyek: [], felelosok: [],
      publikalt: false, faliujsag: false, jelentkezheto: false, holiday_tipus: null,
      ebed_lemondas: false, _ebed_tarolt: false,
      letszam: 0, minimum: null, ar: null, ar_penznem: 'HUF', ar_tipus: '',
      jelentkezes_tol: null, jelentkezes_ig: null,
      // Tanóra-alapú időzítés és értesítés – alapból kikapcsolva.
      ora_alapu: false, ora_tol: null, ora_ig: null,
      ertesites_elore_ora: null, ertesites_aznap: false,
      // Alapból belső üzenet – ez a korábbi (és a legkevésbé tolakodó) viselkedés.
      ertesites_csatorna: 'uzenet',
      felelos: null,
    };
    this.felelosSzuro = '';
    this.erintett = null;
    this.ebedInfo = null;
    this.efPillanat = JSON.stringify(this.ef);
    this.szerkesztomodal.present();
  }

  szerkeszt(e: any) {
    const allDay = !!e.egesz_napos;
    this.ef = {
      ...e,
      kezdes: this.toLocalInput(e.kezdes, allDay), vege: this.toLocalInput(e.vege, allDay),
      egesz_napos: allDay, publikalt: !!e.publikalt, faliujsag: !!e.faliujsag,
      jelentkezheto: !!e.jelentkezheto,
      ar_penznem: penznemKod(e.ar_penznem),
      scope_ids: Array.isArray(e.scope_ids) ? [...e.scope_ids] : [],
      dolgozoi_kor: e.dolgozoi_kor || 'mind',
      erintett_szemelyek: Array.isArray(e.erintett_szemelyek) ? [...e.erintett_szemelyek] : [],
      felelosok: Array.isArray(e.felelosok) ? [...e.felelosok] : (e.felelos ? [e.felelos] : []),
      ora_alapu: e.ora_tol !== null && e.ora_tol !== undefined,
      ertesites_aznap: !!e.ertesites_aznap,
      ertesites_csatorna: e.ertesites_csatorna || 'uzenet',
      felelos: e.felelos || null,
      // A TÁROLT állapot külön: a kapcsoló átállítását a kiszolgáló ehhez méri.
      ebed_lemondas: !!e.ebed_lemondas, _ebed_tarolt: !!e.ebed_lemondas,
      alprogramok: Array.isArray(e.alprogramok) ? e.alprogramok : [],
    };
    this.felelosSzuro = '';
    this.erintett = null;
    this.ebedInfo = null;
    //  Al-program PDF-szűrő: alapból mind benne van.
    this.alPdfKi = Object.fromEntries((this.ef.alprogramok || []).map((a: any) => [a.id, true]));
    this.efPillanat = JSON.stringify(this.ef);
    this.szerkesztomodal.present();
    //  Az al-program nem kerül tanügyi naptárba és ebédet sem mond le (a fő eseménytől függ).
    if (e.id && e.scope_tipus !== 'dolgozo' && !e.szulo_id) this.ebedElonezetBetolt();
    // Meglévő eseménynél rögtön megmutatjuk, kit érint – ez a döntés alapja.
    if (e.id) this.erintettBetolt(e.id);
    this.szunnapOrak = null;
    if (e.id && !e.szulo_id) this.szunnapOrakBetolt(e.id);
  }
  closeSzerkeszto() { this.szerkesztomodal.dismiss(); }

  /* ══════════════════════════════════════════════════════════════════════
   *  AL-PROGRAMOK SZERKESZTÉSE
   *
   *  Egy eseményen (pl. nyílt nap) belül több, külön jelentkezhető program: saját
   *  időpont, férőhely, ár, jelentkezési időszak. A hatókört, a publikálást és a
   *  felelősöket a fő eseménytől örökli – a kiszolgáló vezeti át minden mentéskor.
   *  Ugyanaz a szerkesztőablak, csak az örökölt mezők nélkül; mentés után visszavisz
   *  a fő eseményhez.
   * ═══════════════════════════════════════════════════════════════════ */

  /** A szerkesztő megnyitáskori állapota – hogy átlépéskor ne vesszen el szó nélkül a módosítás. */
  private efPillanat = '';
  alPdfKi: Record<string, boolean> = {};
  alPdfKulonOldal = true;

  get alSzuloNev(): string {
    const sz = (this.esemenyek || []).find((e) => String(e.id) === String(this.ef?.szulo_id));
    return sz?.nev || '';
  }

  private async atlepAlprogramra(uj: any) {
    if (this.efPillanat && JSON.stringify(this.ef) !== this.efPillanat
      && !confirm('A fő esemény el nem mentett módosításai elvesznek. Folytatod?')) return;
    await this.szerkesztomodal.dismiss();
    if (uj.id) { this.szerkeszt(uj); return; }
    this.ef = uj;
    this.felelosSzuro = '';
    this.erintett = null;
    this.ebedInfo = null;
    this.szunnapOrak = null;
    this.efPillanat = JSON.stringify(this.ef);
    this.szerkesztomodal.present();
  }

  async ujAlprogram() {
    const sz = this.ef;
    if (!sz?.id || sz.szulo_id) return;
    /*  Kiinduló időpont: a fő esemény kezdete (egész naposnál 8–9 óra), a jelentkezési
     *  időszak és a pénznem is az övé – a programhoz rendszerint csak a sávot kell állítani. */
    const nap = String(sz.kezdes || '').slice(0, 10);
    const kezdes = sz.egesz_napos ? (nap ? `${nap}T08:00` : '') : sz.kezdes;
    const vege = sz.egesz_napos ? (nap ? `${nap}T09:00` : '') : sz.vege;
    await this.atlepAlprogramra({
      id: null, szulo_id: sz.id, nev: '', tipus: sz.tipus, tema: '', ikon: sz.ikon || '',
      kezdes, vege, egesz_napos: false,
      scope_tipus: sz.scope_tipus, scope_ids: [...(sz.scope_ids || [])], dolgozoi_kor: sz.dolgozoi_kor || 'mind',
      erintett_szemelyek: [], felelosok: [...(sz.felelosok || [])],
      publikalt: !!sz.publikalt, faliujsag: false, jelentkezheto: true, holiday_tipus: null,
      ebed_lemondas: false, _ebed_tarolt: false,
      letszam: 0, minimum: null, ar: null, ar_penznem: penznemKod(sz.ar_penznem), ar_tipus: '',
      jelentkezes_tol: sz.jelentkezes_tol || null, jelentkezes_ig: sz.jelentkezes_ig || null,
      ora_alapu: false, ora_tol: null, ora_ig: null,
      ertesites_elore_ora: null, ertesites_aznap: false, ertesites_csatorna: sz.ertesites_csatorna || 'uzenet',
      felelos: sz.felelos || null, alprogramok: [],
    });
  }

  async alprogramSzerkeszt(a: any) { await this.atlepAlprogramra(a); }

  /** Al-programból vissza a fő eseményhez (mentés nélkül). */
  async visszaSzulohoz() {
    const szuloId = this.ef?.szulo_id;
    await this.szerkesztomodal.dismiss();
    this.szuloSzerkesztoNyit(szuloId);
  }

  private szuloSzerkesztoNyit(szuloId: any) {
    const sz = (this.esemenyek || []).find((e) => String(e.id) === String(szuloId));
    if (sz && this.szerkesztheto(sz)) this.szerkeszt(sz);
  }

  alJelentkezoDb(a: any): number {
    return Array.isArray(a?.jelentkezok) ? a.jelentkezok.length : 0;
  }

  /*  TANÍTÁS NÉLKÜLI NAP ÓRÁI. Munkaszüneti napnál / iskolai szünetnél a mentés a nap összes
   *  óráját törli (archívumba); itt látszik, hány órát, és innen állíthatók vissza. */
  szunnapOrak: { torolt_orak: number; napok: number } | null = null;
  szunnapFut = false;
  get szunnapTipus(): boolean { return [0, 1].includes(Number(this.ef?.holiday_tipus)) && this.ef?.holiday_tipus !== null; }
  async szunnapOrakBetolt(id: string) {
    try {
      this.szunnapOrak = await firstValueFrom(this.http.get<any>(
        `/api/tanevrendje/bejegyzes/${id}/szunnap-orak?intezmeny=${encodeURIComponent(this.intezmeny)}`));
    } catch { this.szunnapOrak = null; }
  }
  async szunnapOrakVisszaallitasa() {
    if (!this.ef?.id || !this.szunnapOrak?.torolt_orak) return;
    if (!confirm(`Visszaállítod a nap(ok)ról törölt ${this.szunnapOrak.torolt_orak} órát? A bejegyzés ettől még szünnap marad.`)) return;
    this.szunnapFut = true;
    try {
      const r: any = await firstValueFrom(this.http.post(
        `/api/tanevrendje/bejegyzes/${this.ef.id}/szunnap-orak/visszaallit`, { intezmeny: this.intezmeny }));
      this.data.sendToast(`${r?.visszaallitva || 0} óra visszaállítva.`, 'success');
      await this.szunnapOrakBetolt(this.ef.id);
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Nem sikerült visszaállítani az órákat.', 'error');
    }
    this.szunnapFut = false;
  }

  // Egész napos váltáskor a dátum-mezők formátuma is váltson (date <-> datetime-local),
  // különben az input nem tudja megjeleníteni a meglévő értéket.
  egeszNaposValt() {
    if (!this.ef) return;
    this.ef.kezdes = this.reformatInput(this.ef.kezdes, this.ef.egesz_napos);
    this.ef.vege = this.reformatInput(this.ef.vege, this.ef.egesz_napos);
  }
  private reformatInput(value: string, allDay: boolean): string {
    if (!value) return '';
    if (allDay) return value.slice(0, 10);                       // yyyy-MM-dd
    return value.length === 10 ? `${value}T08:00` : value;       // dátum -> +idő
  }

  // value (ISO/SQL) -> input formátum. allDay esetén csak dátum (a date inputhoz).
  private toLocalInput(value: any, allDay = false): string {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);
    const pad = (n: number) => String(n).padStart(2, '0');
    const datum = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    return allDay ? datum : `${datum}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
  private toSqlDate(value: string): string {
    if (!value) return value;
    return value.replace('T', ' ').length === 16 ? value.replace('T', ' ') + ':00' : value.replace('T', ' ');
  }

  async mentes() {
    if (!this.ef?.nev?.trim()) { this.data.sendToast('A megnevezés kötelező.', 'warning'); return; }
    if (!this.ef?.kezdes || !this.ef?.vege) { this.data.sendToast('A kezdés és vége időpont kötelező.', 'warning'); return; }
    const payload: any = {
      intezmeny: this.intezmeny,
      nev: this.ef.nev, tipus: this.ef.tipus, tema: this.ef.tema || '',
      ikon: this.ef.ikon || this.tipusMeta(this.ef.tipus).icon,
      kezdes: this.toSqlDate(this.ef.kezdes), vege: this.toSqlDate(this.ef.vege),
      egesz_napos: this.ef.egesz_napos ? 1 : 0,
      scope_tipus: this.ef.scope_tipus,
      scope_ids: ['intezmeny', 'dolgozo'].includes(this.ef.scope_tipus) ? [] : (this.ef.scope_ids || []),
      dolgozoi_kor: this.ef.scope_tipus === 'dolgozo' ? (this.ef.dolgozoi_kor || 'mind') : '',
      erintett_szemelyek: this.ef.erintett_szemelyek || [],
      publikalt: this.ef.publikalt ? 1 : 0,
      faliujsag: this.ef.faliujsag ? 1 : 0,
      // Dolgozói programnak nincs érintett tanulója: ott a kapcsoló nem értelmezett.
      ebed_lemondas: this.ef.ebed_lemondas && this.ef.scope_tipus !== 'dolgozo' ? 1 : 0,
      holiday_tipus: (this.ef.holiday_tipus === null || this.ef.holiday_tipus === undefined) ? null : Number(this.ef.holiday_tipus),
      jelentkezheto: this.ef.jelentkezheto ? 1 : 0,
      letszam: this.ef.jelentkezheto ? (this.ef.letszam || 0) : 0,
      minimum: this.ef.jelentkezheto ? this.ef.minimum : null,
      ar: this.ef.jelentkezheto ? this.ef.ar : null,
      ar_penznem: penznemKod(this.ef.ar_penznem),
      ar_tipus: this.ef.jelentkezheto ? this.ef.ar_tipus : null,
      jelentkezes_tol: this.ef.jelentkezheto ? this.ef.jelentkezes_tol : null,
      jelentkezes_ig: this.ef.jelentkezheto ? this.ef.jelentkezes_ig : null,
      // A tanóra-kötés csak akkor megy fel, ha tényleg tanórához kötötték: enélkül a
      // 0 óraszám az egész napot érintené.
      ora_tol: this.ef.ora_alapu ? Number(this.ef.ora_tol) : null,
      ora_ig: this.ef.ora_alapu ? Number(this.ef.ora_ig ?? this.ef.ora_tol) : null,
      ertesites_elore_ora: this.ef.ertesites_elore_ora === null || this.ef.ertesites_elore_ora === ''
        ? null : Number(this.ef.ertesites_elore_ora),
      ertesites_aznap: this.ef.ertesites_aznap ? 1 : 0,
      ertesites_csatorna: this.ef.ertesites_csatorna || 'uzenet',
      // Több felelős is lehet; a kiszolgáló az elsőt teszi a régi `felelos` mezőbe.
      felelosok: this.ef.felelosok || [],
      // Al-program: a fő esemény azonosítója (új felvételkor számít; az örökölt mezőket a kiszolgáló adja).
      ...(this.ef.szulo_id ? { szulo_id: this.ef.szulo_id } : {}),
    };
    await this.data.showLoading('Mentés...');
    try {
      const valasz: any = this.ef.id
        ? await firstValueFrom(this.http.put(`/api/tanevrendje/bejegyzes/${this.ef.id}`, payload))
        : await firstValueFrom(this.http.post(`/api/tanevrendje/${this.intezmenyPath}`, payload));
      await this.data.hideLoading();
      const szuloId = this.ef.szulo_id;
      await this.szerkesztomodal.dismiss();
      await this.loadEsemenyek();
      this.data.sendToast(this.mentesUzenet(valasz?.ebed_lemondas_eredmeny),
        valasz?.ebed_lemondas_eredmeny?.hiba ? 'warning' : 'success');
      //  Al-program mentése után vissza a fő eseményhez – ott a programok listája.
      if (szuloId) this.szuloSzerkesztoNyit(szuloId);
    } catch (e: any) {
      await this.data.hideLoading();
      /*  A KISZOLGÁLÓ INDOKLÁSA SZÁMÍT. Eddig minden hibából ugyanaz a mondat lett
       *  („Nem sikerült menteni"), így aki jogosultság miatt kapott elutasítást, nem
       *  tudta meg, hogy MIÉRT – és a hibajegyből sem derült ki. */
      this.data.sendToast(e?.error?.error || 'Nem sikerült menteni a bejegyzést.', 'error');
    }
  }

  /* ══════════════════════════════════════════════════════════════════════
   *  AUTOMATIKUS EBÉDLEMONDÁS AZ ÉRINTETT TANULÓKNAK
   *
   *  Bekapcsolva a rendszer a program minden napjára lemondja az érintett tanulók
   *  ebédjét, és az étkezés-felületen azt a napot zárolja. Csak jövőbeli, még nem
   *  számlázott programnál állítható át – ezt a kiszolgáló dönti el (mentéskor is
   *  ellenőrzi); a felület csak előre jelzi, hogy ne a mentésnél derüljön ki.
   * ═══════════════════════════════════════════════════════════════════ */

  ebedInfo: any = null;
  ebedFut = false;

  /** A program első napja (YYYY-MM-DD) a szerkesztő állapotából. */
  private ebedElsoNap(): string {
    return String(this.ef?.kezdes || '').slice(0, 10);
  }

  /** Miért NEM állítható át most a kapcsoló? `null`, ha átállítható. */
  ebedTiltasOka(): string | null {
    const f = this.ef || {};
    if (f.scope_tipus === 'dolgozo') return 'Dolgozói programnak nincs érintett tanulója.';
    const elso = this.ebedElsoNap();
    const most = new Date();
    const ma = `${most.getFullYear()}-${String(most.getMonth() + 1).padStart(2, '0')}-${String(most.getDate()).padStart(2, '0')}`;
    if (elso && elso <= ma) {
      return f._ebed_tarolt
        ? 'A program már elkezdődött vagy elmúlt: a lemondás nem vonható vissza.'
        : 'Csak jövőbeli (legkorábban holnap kezdődő) programnál kapcsolható be – a mai és a korábbi napok ebédje már a konyhán van.';
    }
    // A kiszolgáló előnézete (pl. már számlázott napok) – csak a tárolt állapotból indulva számít.
    if (this.ebedInfo && !this.ebedInfo.allithato && !!f.ebed_lemondas === !!f._ebed_tarolt) {
      return this.ebedInfo.ok || 'A kapcsoló most nem állítható át.';
    }
    return null;
  }

  async ebedElonezetBetolt() {
    if (!this.ef || this.ef.scope_tipus === 'dolgozo' || !this.ef.kezdes) { this.ebedInfo = null; return; }
    this.ebedFut = true;
    try {
      this.ebedInfo = await firstValueFrom(this.http.post(
        `/api/naptar-ebedlemondas/elonezet/${this.intezmenyPath}`, {
          id: this.ef.id || null,
          kezdes: this.toSqlDate(this.ef.kezdes), vege: this.toSqlDate(this.ef.vege || this.ef.kezdes),
          scope_tipus: this.ef.scope_tipus,
          scope_ids: ['intezmeny', 'dolgozo'].includes(this.ef.scope_tipus) ? [] : (this.ef.scope_ids || []),
          jelentkezheto: this.ef.jelentkezheto ? 1 : 0,
        }));
    } catch (e: any) {
      this.ebedInfo = null;
    } finally {
      this.ebedFut = false;
    }
  }

  /** A mentés visszajelzése – az ebédlemondás eredményével, ha volt. */
  private mentesUzenet(eredmeny: any): string {
    if (!eredmeny) return 'Mentve.';
    if (eredmeny.hiba) return `Mentve, de ${eredmeny.hiba}`;
    const reszek: string[] = [];
    if (eredmeny.lemondva) reszek.push(`${eredmeny.lemondva} ebéd lemondva`);
    if (eredmeny.visszarendelve) reszek.push(`${eredmeny.visszarendelve} ebéd visszarendelve`);
    if (eredmeny.kihagyva_szamlazott) reszek.push(`${eredmeny.kihagyva_szamlazott} számlázott nap kimaradt`);
    return reszek.length ? `Mentve. ${reszek.join(', ')}.` : 'Mentve.';
  }

  /* ══════════════════════════════════════════════════════════════════════
   *  TANÓRA-ALAPÚ IDŐZÍTÉS ÉS ÉRTESÍTÉS
   *
   *  Egy program a gyakorlatban tanárok óráit viszi el. Eddig ezt kézzel kellett
   *  kikeresni az órarendből, és egyenként szólni. Itt a rendszer válogatja le.
   * ═══════════════════════════════════════════════════════════════════ */

  /** Kit érint: tanárok a saját óráikkal + a tanulók. */
  erintett: any = null;
  erintettFut = false;
  kuldesFut = false;

  /** A szerkesztőben ÉPP beállított, az érintetteket befolyásoló mezők. */
  private erintettElonezetAllapot(): any {
    const f = this.ef || {};
    return {
      scope_tipus: f.scope_tipus,
      scope_ids: Array.isArray(f.scope_ids) ? f.scope_ids : [],
      dolgozoi_kor: f.scope_tipus === 'dolgozo' ? (f.dolgozoi_kor || 'mind') : '',
      erintett_szemelyek: Array.isArray(f.erintett_szemelyek) ? f.erintett_szemelyek : [],
      jelentkezheto: f.jelentkezheto ? 1 : 0,
      ora_tol: f.ora_alapu ? Number(f.ora_tol) : null,
      ora_ig: f.ora_alapu ? Number(f.ora_ig ?? f.ora_tol) : null,
      felelos: f.felelos || null,
    };
  }

  async erintettBetolt(id?: string) {
    const azonosito = id || this.ef?.id;
    if (!azonosito) return;
    this.erintettFut = true;
    try {
      /*  A SZERKESZTŐ JELENLEGI ÁLLAPOTÁT kérdezzük, nem a mentettet. Ha valaki
       *  átállította a hatókört (például „csak a dolgozók") és mentés előtt kattint,
       *  eddig a RÉGI hatókörre jött a válasz: tanulókat sorolt fel, dolgozókat nem. */
      this.erintett = await firstValueFrom(this.http.post(
        `/api/naptar-ertesito/erintett/${azonosito}`,
        { modositasok: this.erintettElonezetAllapot() }));
    } catch (e: any) {
      this.erintett = null;
      this.data.sendToast(e?.error?.error || 'Az érintettek lekérése nem sikerült.', 'error');
    } finally {
      this.erintettFut = false;
    }
  }

  /**
   *  A tanóra-tartományból időpont a CSENGETÉSI REND szerint.
   *
   *  Nem magunk számoljuk: ha átszervezik a csengetést, az esemény együtt mozog vele.
   */
  async oraIdopontBetolt() {
    if (!this.ef?.ora_alapu || !this.ef?.ora_tol) return;
    const nap = String(this.ef.kezdes || '').slice(0, 10);
    if (!nap) { this.data.sendToast('Előbb add meg a dátumot.', 'warning'); return; }
    try {
      const p = new URLSearchParams({ datum: nap, ora_tol: String(this.ef.ora_tol),
                                      ora_ig: String(this.ef.ora_ig ?? this.ef.ora_tol) });
      const r: any = await firstValueFrom(this.http.get(
        `/api/naptar-ertesito/ora-idopont/${this.intezmenyPath}?${p.toString()}`));
      this.ef.kezdes = String(r.kezdes).replace(' ', 'T').slice(0, 16);
      this.ef.vege = String(r.vege).replace(' ', 'T').slice(0, 16);
      this.ef.egesz_napos = false;
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Nem sikerült az órákból időpontot számolni.', 'warning');
    }
  }

  /** Értesítés kiküldése MOST (a beállított időzítéstől függetlenül). */
  async ertesitestKuld() {
    if (!this.ef?.id) { this.data.sendToast('Előbb mentsd el az eseményt.', 'warning'); return; }
    const db = (this.erintett?.tanarok?.length || 0) + (this.erintett?.tanulok?.length || 0);
    if (!confirm(`Értesítés kiküldése most ${this.erintett?.tanarok?.length || 0} tanárnak és `
      + `${this.erintett?.tanulok?.length || 0} tanulónak (összesen ${db} címzett)?`)) return;
    this.kuldesFut = true;
    try {
      const r: any = await firstValueFrom(
        this.http.post(`/api/naptar-ertesito/kuldes/${this.ef.id}`, { fajta: 'kezi' }));
      /*  MEGMONDJUK, MI MENT EL LEVÉLBEN. „Csak e-mail" beállításnál is kaphat valaki
       *  belső üzenetet (ha nincs címe, vagy elakadt a küldés) – ezt nem elhallgatni
       *  kell, hanem kiírni, különben a feladó azt hiszi, mindenki levelet kapott. */
      let uzenet = `Kiküldve: ${r.tanar_db} tanár, ${r.tanulo_db} tanuló.`;
      if (r.csatorna !== 'uzenet') uzenet += ` Ebből ${r.email_db || 0} e-mailben.`;
      if (r.email_nelkul?.length) {
        uzenet += ` Levél nélkül (belső üzenetet kaptak): ${r.email_nelkul.slice(0, 5).join(', ')}`
          + (r.email_nelkul.length > 5 ? ` és még ${r.email_nelkul.length - 5} fő.` : '.');
      }
      this.data.sendToast(uzenet, 'success');
      await this.erintettBetolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A kiküldés nem sikerült.', 'error');
    } finally {
      this.kuldesFut = false;
    }
  }

  async torles() {
    if (!this.ef?.id) return;
    const alDb = (this.ef.alprogramok || []).length;
    if (!confirm(alDb
      ? `Biztosan törlöd ezt a bejegyzést? A ${alDb} al-programja és azok jelentkezései is törlődnek.`
      : 'Biztosan törlöd ezt a bejegyzést?')) return;
    await this.data.showLoading('Törlés...');
    try {
      await firstValueFrom(
        this.http.request('delete', `/api/tanevrendje/bejegyzes/${this.ef.id}`, { body: { intezmeny: this.intezmeny } })
      );
      await this.data.hideLoading();
      const szuloId = this.ef.szulo_id;
      await this.szerkesztomodal.dismiss();
      await this.loadEsemenyek();
      this.data.sendToast('Törölve.', 'success');
      if (szuloId) this.szuloSzerkesztoNyit(szuloId);
    } catch (e: any) {
      await this.data.hideLoading();
      this.data.sendToast(e?.error?.error || 'Nem sikerült törölni a bejegyzést.', 'error');
    }
  }

  get szerkesztoJelentkezok(): string[] {
    return Array.isArray(this.ef?.jelentkezok) ? this.ef.jelentkezok.map((x: any) => String(x)) : [];
  }

  /* ══════════════════════════════════════════════════════════════════════
   *  FELIRATKOZÁS SAJÁT NAPTÁRBA (iCal)
   * ═══════════════════════════════════════════════════════════════════════ */

  async feliratkozasNyitas() {
    this.linkFut = true;
    this.linkek = null;
    await this.feliratkozasmodal.present();
    try {
      this.linkek = await firstValueFrom(this.http.get(
        `/api/tanevrendje/ical/linkek/${this.intezmenyPath}?tipus=${this.loginMode || 'dolgozo'}`));
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A feliratkozási címek nem kérhetők le.', 'error');
    } finally {
      this.linkFut = false;
    }
  }

  /*  A címet TELJES alakban adjuk: egy külső naptárba nem lehet „/api/…"-t
   *  beilleszteni, oda a kiszolgáló nevével együtt kell a cím. */
  teljesCim(ut: string): string {
    if (!ut) return '';
    try { return new URL(ut, window.location.origin).toString(); } catch (e) { return ut; }
  }

  async masol(ut: string) {
    const cim = this.teljesCim(ut);
    try {
      await navigator.clipboard.writeText(cim);
      this.data.sendToast('A cím a vágólapra került.', 'success');
    } catch (e) {
      this.data.sendToast('A másolás nem sikerült – jelöld ki és másold kézzel.', 'warning');
    }
  }

  /** Új kulcs: a korábban kiadott címek azonnal érvénytelenek lesznek. */
  async ujraLink() {
    if (!confirm('Új címeket kérsz? A korábbi címek AZONNAL érvénytelenné válnak, '
      + 'tehát ahol már feliratkoztál velük, ott újra be kell állítani az újat.')) return;
    this.linkFut = true;
    try {
      await firstValueFrom(this.http.post(
        `/api/tanevrendje/ical/ujralink/${this.intezmenyPath}`, {}));
      this.linkek = await firstValueFrom(this.http.get(
        `/api/tanevrendje/ical/linkek/${this.intezmenyPath}?tipus=${this.loginMode || 'dolgozo'}`));
      this.data.sendToast('Új címek készültek.', 'success');
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az új cím nem készült el.', 'error');
    } finally {
      this.linkFut = false;
    }
  }

  // ── Excel import ──────────────────────────────────────────────────────
  async sablonLetoltes() {
    try {
      const blob = await firstValueFrom(
        this.http.get('/api/tanevrendje/import-sablon', { responseType: 'blob' })
      );
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = 'tanev-rendje-sablon.xlsx';
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      this.data.sendToast('Nem sikerült letölteni a sablont.', 'error');
    }
  }

  async importValtozas(event: any) {
    const file: File = event?.target?.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file);
    await this.data.showLoading('Importálás...');
    try {
      const rsp: any = await firstValueFrom(
        this.http.post(`/api/tanevrendje/import/${this.intezmenyPath}`, fd)
      );
      await this.data.hideLoading();
      const hibak = Array.isArray(rsp?.errors) ? rsp.errors : [];
      this.data.sendToast(
        `${rsp?.imported || 0} esemény importálva.` + (hibak.length ? ` ${hibak.length} sor kihagyva.` : ''),
        hibak.length ? 'warning' : 'success'
      );
      if (hibak.length) console.warn('Import hibák:', hibak);
      await this.loadEsemenyek();
    } catch (err: any) {
      await this.data.hideLoading();
      this.data.sendToast(err?.error?.error || 'Nem sikerült importálni a fájlt.', 'error');
    } finally {
      if (event?.target) event.target.value = '';
    }
  }

  /** A tanév rendjéről szóló (évente megjelenő) rendelet beemelése – egy gombnyomással, előnézettel. */
  async rendeletBeemeles() {
    const m = await this.modalCtrl.create({ component: TanevrendjeRendeletModalComponent, componentProps: { intezmeny: this.intezmenyPath } });
    await m.present();
    const { data } = await m.onDidDismiss();
    if (data?.valtozott) await this.loadEsemenyek();
  }

  /*  TANTERMEN KÍVÜLI, DIGITÁLIS MUNKAREND (backend: digitalis-munkarend.js). A rendeletből beemelt
   *  (vagy kézzel felvett) „… digitális munkarend …” bejegyzésből indítható az elrendelés: az időszak
   *  és a 9–11. évfolyam előtöltve, az osztályok választhatók. */
  dmBejegyzesE(e: any): boolean {
    return /digit[aá]lis munkarend/i.test(String(e?.nev || ''));
  }

  async digitalisMunkarend(e: any) {
    if (!e?.id) return;
    const m = await this.modalCtrl.create({
      component: DigitalisMunkarendModalComponent,
      componentProps: {
        intezmeny: this.intezmeny, tktId: e.id, tema: e.tema || '',
        tol: this.toLocalInput(e.kezdes, true), ig: this.toLocalInput(e.vege || e.kezdes, true),
        //  A rendelet (5. §) a 9–11. évfolyamot nevezi meg – a modalban módosítható.
        evfolyamok: [9, 10, 11],
      },
    });
    await m.present();
  }

  /** A meghirdetett foglalkozás átemelése az órarendbe (külön ablak, előnézettel). */
  async orarendbeEmel() {
    if (!this.ef?.id) return;
    const m = await this.modalCtrl.create({
      component: TktOrarendModalComponent,
      componentProps: { tktId: this.ef.id, intezmeny: this.intezmeny },
    });
    await m.present();
  }

  async nevsorPdf() {
    const oktazonok = this.szerkesztoJelentkezok;
    if (!oktazonok.length) { this.data.sendToast('Nincs jelentkező.', 'warning'); return; }
    await this.data.showLoading('Névsor készítése...');
    try {
      const rows: any[] = await firstValueFrom(
        this.http.post<any[]>(`/api/tkt/resztvevok/${this.intezmenyPath}`, { oktazonok })
      );
      const body = (rows || []).map((row, i) => {
        const szulok = Array.isArray(row.szulok) ? row.szulok : [];
        return [
          String(i + 1), row.full_name || '', String(row.oktazon || ''), row.osztaly || '',
          szulok.map((p) => [p.rokonsag, p.nev].filter(Boolean).join(': ')).filter(Boolean).join('\n'),
          szulok.map((p) => p.email).filter(Boolean).join('\n'),
          szulok.map((p) => p.telefon).filter(Boolean).join('\n'),
        ];
      });
      const head = ['#', 'Tanuló', 'Okt. azonosító', 'Osztály', 'Szülő', 'Email', 'Telefon'];
      const safe = String(this.ef.nev || 'esemeny').replace(/[^\p{L}\p{N}]+/gu, '_');
      const fajlnev = `${safe}_jelentkezok.pdf`;
      /*  A kiszolgáló riport-motorja (backend/pdf-riport.js, a munkaidő-elszámolás arculata);
       *  ha nem sikerül, a régi, böngészős PDF készül. */
      try {
        const idopont = this.idopontSzoveg(this.ef);
        await this.data.riportPdf({
          intezmeny: this.intezmeny,
          cim: this.ef.nev || 'Esemény',
          cimKieg: 'jelentkezők',
          alcim: idopont,
          adatsav: [['Esemény', this.ef.nev || ''], ['Időpont', idopont], ['Jelentkezők', String(body.length)]],
          lapmeret: 'A4', tajolas: 'fekvo', betumeret: 8.5,
          tablak: [{
            cim: 'Jelentkezők névsora', osszegzes: `${body.length} fő`,
            oszlopok: [
              { nev: head[0], igazitas: 'kozep', szelesseg: '4%' }, { nev: head[1], szelesseg: '17%' },
              { nev: head[2], igazitas: 'bal', szelesseg: '11%' }, { nev: head[3], szelesseg: '7%' }, { nev: head[4], szelesseg: '23%' },
              { nev: head[5], szelesseg: '22%' }, { nev: head[6], igazitas: 'bal', szelesseg: '16%' },
            ],
            sorok: body.map((s) => [s[0], { t: s[1], fej: true }, ...s.slice(2)]),
          }],
          lablec: { kelt: true },
          fajlnev,
        }, fajlnev, 'letolt');
        return;
      } catch (e: any) {
        console.warn('Jelentkezői névsor PDF (kiszolgáló) hiba, böngészős tartalék:', e);
        this.data.sendToast(`A PDF a régi formában készült (${e?.message || e}).`, 'warning');
      }
      const pdf = new jsPDF('l', 'mm', 'a4');
      pdf.addFileToVFS('Bitter-Regular-normal.ttf', font);
      pdf.addFont('Bitter-Regular-normal.ttf', 'Bitter-Regular', 'normal');
      pdf.addFileToVFS('Bitter-Bold-normal.ttf', fontB);
      pdf.addFont('Bitter-Bold-normal.ttf', 'Bitter-Bold', 'bold');
      pdf.setFont('Bitter-Regular');
      pdf.setFontSize(14);
      pdf.text(`${this.ef.nev || 'Esemény'} - jelentkezők`, 14, 14);
      autoTable(pdf, {
        startY: 22,
        head: [head],
        body, theme: 'grid',
        styles: { font: 'Bitter-Regular', fontSize: 8, overflow: 'linebreak' },
        headStyles: { fillColor: [56, 128, 255], font: 'Bitter-Bold', fontStyle: 'bold' },
      });
      pdf.save(fajlnev);
    } catch (e) {
      this.data.sendToast('Nem sikerült elkészíteni a névsort.', 'error');
    } finally { await this.data.hideLoading(); }
  }

  /* ══════════════════════════════════════════════════════════════════════
   *  AL-PROGRAMOK NÉVSORA (PDF), SZŰRHETŐEN
   *
   *  A kiválasztott al-programok egy dokumentumban: elöl egy összesítő (program,
   *  időpont, létszám, ár – a pénzügyi kezelőnek a befizetett összeg és a hátralék is),
   *  utána programonként a jelentkezők a szülők elérhetőségével. A résztvevőket és a
   *  befizetéseket a tevékenység-modul adja (backend/tkt-befizetes.js) – a pénzügyi
   *  oszlop csak annak jelenik meg, akinek a kiszolgáló ezt megengedi.
   * ═══════════════════════════════════════════════════════════════════ */
  get alPdfValasztottDb(): number {
    return (this.ef?.alprogramok || []).filter((a: any) => this.alPdfKi[a.id]).length;
  }

  alPdfMind(be: boolean) {
    this.alPdfKi = Object.fromEntries((this.ef?.alprogramok || []).map((a: any) => [a.id, be]));
  }

  async alprogramPdf() {
    const valasztott = (this.ef?.alprogramok || []).filter((a: any) => this.alPdfKi[a.id]);
    if (!valasztott.length) { this.data.sendToast('Válassz legalább egy al-programot.', 'warning'); return; }
    await this.data.showLoading('Névsor készítése...');
    try {
      const reszletek: any[] = await Promise.all(valasztott.map((a: any) => firstValueFrom(this.http.get<any>(
        `/api/tkt-befizetes/esemeny/${encodeURIComponent(a.id)}`, { params: { intezmeny: this.intezmeny } }))));
      const kulsosE = (k: string) => /^k:[0-9a-f]{12}$/.test(String(k));
      const tanulok = [...new Set(reszletek.flatMap((r) => (r?.resztvevok || [])
        .filter((s: any) => s.resztvevo && !kulsosE(s.oktazon)).map((s: any) => String(s.oktazon))))];
      const elerhetoseg = new Map<string, any>();
      if (tanulok.length) {
        const sorok: any[] = await firstValueFrom(
          this.http.post<any[]>(`/api/tkt/resztvevok/${this.intezmenyPath}`, { oktazonok: tanulok })) || [];
        sorok.forEach((s) => elerhetoseg.set(String(s.oktazon), s));
      }
      const penzugy = reszletek.some((r) => r?.jog?.kezelheti);
      const osszeg = (v: any, p: any) => (v === null || v === undefined ? '' : osszegSzoveg(v, p));

      const osszesito = {
        cim: 'Al-programok', osszegzes: `${valasztott.length} program`,
        oszlopok: [
          { nev: 'Program', szelesseg: penzugy ? '30%' : '40%' }, { nev: 'Időpont', szelesseg: '24%' },
          { nev: 'Jelentkezők', igazitas: 'kozep', szelesseg: '12%' }, { nev: 'Ár', igazitas: 'jobb', szelesseg: penzugy ? '10%' : '24%' },
          ...(penzugy ? [{ nev: 'Befizetve', igazitas: 'jobb', szelesseg: '12%' }, { nev: 'Hátralék', igazitas: 'jobb', szelesseg: '12%' }] : []),
        ],
        sorok: valasztott.map((a: any, i: number) => {
          const r = reszletek[i] || {};
          const fo = (r.resztvevok || []).filter((s: any) => s.resztvevo).length;
          const pn = r.esemeny?.ar_penznem || a.ar_penznem;
          return [
            { t: a.nev || '', fej: true }, this.idopontSzoveg(a),
            a.letszam ? `${fo} / ${a.letszam}` : String(fo),
            a.ar ? osszeg(a.ar, pn) + (a.ar_tipus ? ` / ${a.ar_tipus}` : '') : '–',
            ...(penzugy ? (r.osszesites
              ? [osszeg(r.osszesites.befizetve, pn), r.osszesites.hatralek === null ? '–' : osszeg(r.osszesites.hatralek, pn)]
              : ['', '']) : []),
          ];
        }),
      };

      const programTablak = valasztott.map((a: any, i: number) => {
        const r = reszletek[i] || {};
        const kezelo = !!r?.jog?.kezelheti;
        const resztvevok = (r.resztvevok || []).filter((s: any) => s.resztvevo);
        const pn = r.esemeny?.ar_penznem || a.ar_penznem;
        return {
          cim: `${a.nev || 'Program'} – ${this.idopontSzoveg(a)}`,
          osszegzes: `${resztvevok.length} fő${a.letszam ? ` / ${a.letszam}` : ''}`,
          ujOldal: this.alPdfKulonOldal && (i > 0 || valasztott.length > 1),
          oszlopok: [
            { nev: '#', igazitas: 'kozep', szelesseg: '4%' }, { nev: 'Név', szelesseg: '18%' },
            { nev: 'Osztály', szelesseg: '8%' }, { nev: 'Szülő', szelesseg: kezelo ? '20%' : '24%' },
            { nev: 'Email', szelesseg: kezelo ? '20%' : '27%' }, { nev: 'Telefon', igazitas: 'bal', szelesseg: kezelo ? '14%' : '19%' },
            ...(kezelo ? [{ nev: 'Befizetés', igazitas: 'jobb', szelesseg: '16%' }] : []),
          ],
          sorok: resztvevok.map((s: any, j: number) => {
            const e = elerhetoseg.get(String(s.oktazon));
            const szulok = Array.isArray(e?.szulok) ? e.szulok : [];
            return [
              String(j + 1), { t: s.nev || e?.full_name || '', fej: true },
              s.kulsos ? 'külsős' : (s.osztaly || e?.osztaly || ''),
              s.kulsos ? (s.megjegyzes || '')
                : szulok.map((p: any) => [p.rokonsag, p.nev].filter(Boolean).join(': ')).filter(Boolean).join('\n'),
              szulok.map((p: any) => p.email).filter(Boolean).join('\n'),
              szulok.map((p: any) => p.telefon).filter(Boolean).join('\n'),
              ...(kezelo ? [s.ar ? `${osszeg(s.befizetve || 0, pn)} / ${osszeg(s.ar, pn)}` : osszeg(s.befizetve || 0, pn)] : []),
            ];
          }),
        };
      });

      const egyedi = new Set(reszletek.flatMap((r) => (r?.resztvevok || []).filter((s: any) => s.resztvevo).map((s: any) => s.oktazon)));
      const safe = String(this.ef.nev || 'esemeny').replace(/[^\p{L}\p{N}]+/gu, '_');
      const fajlnev = `${safe}_al-programok.pdf`;
      const idopont = this.idopontSzoveg(this.ef);
      await this.data.riportPdf({
        intezmeny: this.intezmeny,
        cim: this.ef.nev || 'Esemény',
        cimKieg: 'al-programok',
        alcim: idopont,
        adatsav: [['Esemény', this.ef.nev || ''], ['Időpont', idopont],
                  ['Programok', `${valasztott.length} / ${(this.ef.alprogramok || []).length}`], ['Résztvevők', `${egyedi.size} fő`]],
        lapmeret: 'A4', tajolas: 'fekvo', betumeret: 8.5,
        tablak: [osszesito, ...programTablak],
        lablec: { kelt: true },
        fajlnev,
      }, fajlnev, 'letolt');
    } catch (e: any) {
      console.error('Al-program névsor PDF hiba:', e);
      this.data.sendToast(e?.error?.error || 'Nem sikerült elkészíteni a névsort.', 'error');
    } finally { await this.data.hideLoading(); }
  }

  /** „2026. 10. 19. 08:00 – 09:30” (egész napos eseménynél óra nélkül) – a névsor fejlécébe. */
  private idopontSzoveg(e: any): string {
    const egeszNap = !!Number(e?.egesz_napos);
    const f = (v: any) => {
      const d = v ? new Date(v) : null;
      if (!d || Number.isNaN(d.getTime())) return '';
      return d.toLocaleString('hu-HU', egeszNap
        ? { year: 'numeric', month: '2-digit', day: '2-digit' }
        : { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
    };
    const tol = f(e?.kezdes);
    const ig = f(e?.vege);
    return tol && ig && ig !== tol ? `${tol} – ${ig}` : tol;
  }
}
